import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { SelectWorkflowComponent } from './common/selectcomponent';
class MakeLine extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.makeline',
            group: 'Spatial Constructors',
            title: 'ST Make Line',
            description: `
      This component creates a LineString based on a points column. It will take the points in the order they are in the table.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'points',
                type: WorkflowComponentParamType.Column,
                title: 'Points column',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            }
        ]);
        this.supportedProviders = [
            Provider.BigQuery,
            Provider.Postgres,
            Provider.Redshift,
            Provider.DatabricksRest
        ];
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.BigQuery:
                return dedent `SELECT ST_MAKELINE(ARRAY_AGG(${params.points})) geom
                FROM ${connection.quoteName(params.source)}`;
            case Provider.Postgres:
                return dedent `SELECT ST_MAKELINE(${params.points}) geom
                FROM ${connection.quoteName(params.source)}`;
            case Provider.Redshift:
                return dedent `SELECT
                  CASE WHEN ST_NPOINTS(ST_COLLECT(${params.points})) <= 1 THEN
                    ST_COLLECT(${params.points})
                  ELSE
                    ST_REMOVEPOINT(
                      ST_MAKELINE(
                        ST_GEOMFROMTEXT('POINT (0 0)', ST_SRID(ST_COLLECT(${params.points}))),
                        ST_COLLECT(${params.points})),
                      0)
                  END geom
                  FROM ${connection.quoteName(params.source)}`;
            case Provider.DatabricksRest:
                return dedent `SELECT /*+ REPARTITION(40, geom) */
                  ${connection.processOutputGeogColumn(`ST_MAKELINE(ARRAY_AGG(${connection.processInputGeogColumn(params.points)}))`)} geom
                FROM ${connection.quoteName(params.source)}`;
            default:
                return null;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ connection }) {
        return [
            {
                name: 'geom',
                type: connection.getGeoDataType()
            }
        ];
    }
}
export { MakeLine };
